import rawPosts from './blog-posts.json';
import { BLOG_CONTENT } from './blog-content.generated';

// ── Blog images: add an import + map entry when you add new photos ──
import blog1Jpg from '../assets/blog/blog1.jpg';

const BLOG_IMAGES: Record<string, string> = {
  'blog1.jpg': blog1Jpg,
};

export interface BlogPost {
  id: string;
  title: string;
  date: string;
  category: string;
  coverImage: string;
  photos: string[];
  excerpt: string;
  content: string[];
}

interface BlogPostRaw {
  id: string;
  title: string;
  date: string;
  category: string;
  coverImage: string;
  photos: string[];
  excerpt: string;
}

function resolveImage(filename: string): string {
  if (!filename) return '';
  const src = BLOG_IMAGES[filename];
  if (!src) console.warn(`[blog] Image not registered in blog.ts: ${filename}`);
  return src ?? '';
}

/** Each line (Enter) becomes a paragraph. Blank lines are ignored. */
function parseContent(text: string): string[] {
  return text
    .trim()
    .split('\n')
    .map(p => p.trim())
    .filter(Boolean);
}

function hydrate(post: BlogPostRaw): BlogPost {
  const raw = BLOG_CONTENT[post.id];
  if (!raw) console.warn(`[blog] No .txt file found for id: ${post.id}`);

  return {
    ...post,
    coverImage: resolveImage(post.coverImage),
    photos: post.photos.map(resolveImage).filter(Boolean),
    content: parseContent(raw ?? ''),
  };
}

export const blogPosts: BlogPost[] = (rawPosts as BlogPostRaw[])
  .map(hydrate)
  .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export const blogCategories: string[] = Array.from(
  new Set(blogPosts.map(p => p.category)),
).sort();
